import { ListItemAction, Popover } from 'wix-style-react';
import * as React from 'react';
import s from './header-desktop-languages-popover.scss';
import { Languages } from 'wix-ui-icons-common';
import { useConfigContext } from '../../../../../config-context';
import { getCurrentLanguageText } from './header-desktop-languages-popover-content/languages';
import { HeaderDesktopLanguagesPopoverContent } from './header-desktop-languages-popover-content/header-desktop-languages-popover-content';
export var HeaderDesktopLanguagesPopover = function (_a) {
    var showLanguages = _a.showLanguages;
    var locale = useConfigContext().locale;
    var _b = React.useState(false), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var openPopover = function () {
        setPopoverOpen(true);
    };
    var closePopover = function () {
        setPopoverOpen(false);
    };
    return (React.createElement(Popover, { animate: true, appendTo: "scrollParent", onMouseEnter: openPopover, onMouseLeave: closePopover, placement: "left-start", showArrow: false, shown: popoverOpen, theme: "light", moveBy: { y: -102, x: 17 }, dataHook: "languages-popover", hideDelay: 150 },
        React.createElement(Popover.Element, null,
            React.createElement(ListItemAction, { dataHook: "languages-popover-element", as: "button", prefixIcon: React.createElement(Languages, null), title: getCurrentLanguageText(locale), skin: "dark", className: s.languagesPopoverButton })),
        React.createElement(Popover.Content, null,
            React.createElement(HeaderDesktopLanguagesPopoverContent, { isLoggedIn: true, showLanguages: showLanguages }))));
};
//# sourceMappingURL=header-desktop-languages-popover.js.map